export default "__VITE_ASSET__DJzsfm7J__"